// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,ts_nocheck
// @generated from protobuf file "agency/thread/v1/thread.proto" (package "agency.thread.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { SessionStatus } from "../../session/v1/session";
import { Timestamp } from "../../../google/protobuf/timestamp";
import { Message } from "../../session/v1/session";
/**
 * ThreadMessage represents a message in a thread conversation.
 *
 * @generated from protobuf message agency.thread.v1.ThreadMessage
 */
export interface ThreadMessage {
    /**
     * message_id uniquely identifies this message.
     *
     * @generated from protobuf field: string message_id = 1
     */
    messageId: string;
    /**
     * thread_id is the thread this message belongs to.
     *
     * @generated from protobuf field: string thread_id = 2
     */
    threadId: string;
    /**
     * session_id is the session that generated this message (if applicable).
     *
     * @generated from protobuf field: string session_id = 3
     */
    sessionId: string;
    /**
     * message is the message content.
     *
     * @generated from protobuf field: agency.session.v1.Message message = 4
     */
    message?: Message;
    /**
     * timestamp is when the message was created.
     *
     * @generated from protobuf field: google.protobuf.Timestamp timestamp = 5
     */
    timestamp?: Timestamp;
    /**
     * parent_message_id is the message this replies to (for threading).
     *
     * @generated from protobuf field: string parent_message_id = 6
     */
    parentMessageId: string;
    /**
     * metadata contains additional message context.
     *
     * @generated from protobuf field: map<string, string> metadata = 7
     */
    metadata: {
        [key: string]: string;
    };
}
/**
 * ThreadContext is the seed context maintained by ContextualizerActor.
 *
 * @generated from protobuf message agency.thread.v1.ThreadContext
 */
export interface ThreadContext {
    /**
     * thread_id uniquely identifies this thread.
     *
     * @generated from protobuf field: string thread_id = 1
     */
    threadId: string;
    /**
     * tenant is the tenant this thread belongs to.
     *
     * @generated from protobuf field: string tenant = 2
     */
    tenant: string;
    /**
     * workspace is the workspace this thread belongs to.
     *
     * @generated from protobuf field: string workspace = 3
     */
    workspace: string;
    /**
     * summary is the distilled thread context for new sessions.
     *
     * @generated from protobuf field: string summary = 4
     */
    summary: string;
    /**
     * key_facts are important facts extracted from the conversation.
     *
     * @generated from protobuf field: repeated string key_facts = 5
     */
    keyFacts: string[];
    /**
     * session_history tracks session outcomes in this thread.
     *
     * @generated from protobuf field: repeated agency.thread.v1.ThreadSessionSummary session_history = 6
     */
    sessionHistory: ThreadSessionSummary[];
    /**
     * updated_at is when the context was last updated.
     *
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 7
     */
    updatedAt?: Timestamp;
    /**
     * created_at is when the thread was created.
     *
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 8
     */
    createdAt?: Timestamp;
    /**
     * revision is the context revision for optimistic concurrency.
     *
     * @generated from protobuf field: uint64 revision = 9
     */
    revision: bigint;
}
/**
 * ThreadSessionSummary summarizes a session's outcome for thread context.
 *
 * @generated from protobuf message agency.thread.v1.ThreadSessionSummary
 */
export interface ThreadSessionSummary {
    /**
     * session_id is the session identifier.
     *
     * @generated from protobuf field: string session_id = 1
     */
    sessionId: string;
    /**
     * goal is the session goal.
     *
     * @generated from protobuf field: string goal = 2
     */
    goal: string;
    /**
     * outcome summarizes what was accomplished.
     *
     * @generated from protobuf field: string outcome = 3
     */
    outcome: string;
    /**
     * completed_at is when the session completed.
     *
     * @generated from protobuf field: google.protobuf.Timestamp completed_at = 4
     */
    completedAt?: Timestamp;
    /**
     * status is the final session status.
     *
     * @generated from protobuf field: agency.session.v1.SessionStatus status = 5
     */
    status: SessionStatus;
}
/**
 * ThreadMetadata contains thread-level metadata.
 *
 * @generated from protobuf message agency.thread.v1.ThreadMetadata
 */
export interface ThreadMetadata {
    /**
     * thread_id uniquely identifies this thread.
     *
     * @generated from protobuf field: string thread_id = 1
     */
    threadId: string;
    /**
     * title is a human-readable thread title.
     *
     * @generated from protobuf field: string title = 2
     */
    title: string;
    /**
     * tags are categorization labels.
     *
     * @generated from protobuf field: repeated string tags = 3
     */
    tags: string[];
    /**
     * participants are user IDs involved in the thread.
     *
     * @generated from protobuf field: repeated string participants = 4
     */
    participants: string[];
    /**
     * created_by is the user who created the thread.
     *
     * @generated from protobuf field: string created_by = 5
     */
    createdBy: string;
    /**
     * created_at is when the thread was created.
     *
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 6
     */
    createdAt?: Timestamp;
    /**
     * updated_at is when the thread was last updated.
     *
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 7
     */
    updatedAt?: Timestamp;
    /**
     * archived indicates if the thread is archived.
     *
     * @generated from protobuf field: bool archived = 8
     */
    archived: boolean;
    /**
     * archived_at is when the thread was archived (if applicable).
     *
     * @generated from protobuf field: google.protobuf.Timestamp archived_at = 9
     */
    archivedAt?: Timestamp;
}
// @generated message type with reflection information, may provide speed optimized methods
class ThreadMessage$Type extends MessageType<ThreadMessage> {
    constructor() {
        super("agency.thread.v1.ThreadMessage", [
            { no: 1, name: "message_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 2, name: "thread_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 3, name: "session_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "128", pattern: "^([a-z0-9][a-z0-9-]*[a-z0-9])?$" } } } },
            { no: 4, name: "message", kind: "message", T: () => Message, options: { "buf.validate.field": { required: true } } },
            { no: 5, name: "timestamp", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 6, name: "parent_message_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "128" } } } },
            { no: 7, name: "metadata", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ }, options: { "buf.validate.field": { map: { maxPairs: "20", keys: { string: { minLen: "1", maxLen: "128" } }, values: { string: { maxLen: "2048" } } } } } }
        ]);
    }
    create(value?: PartialMessage<ThreadMessage>): ThreadMessage {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.messageId = "";
        message.threadId = "";
        message.sessionId = "";
        message.parentMessageId = "";
        message.metadata = {};
        if (value !== undefined)
            reflectionMergePartial<ThreadMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ThreadMessage): ThreadMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string message_id */ 1:
                    message.messageId = reader.string();
                    break;
                case /* string thread_id */ 2:
                    message.threadId = reader.string();
                    break;
                case /* string session_id */ 3:
                    message.sessionId = reader.string();
                    break;
                case /* agency.session.v1.Message message */ 4:
                    message.message = Message.internalBinaryRead(reader, reader.uint32(), options, message.message);
                    break;
                case /* google.protobuf.Timestamp timestamp */ 5:
                    message.timestamp = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.timestamp);
                    break;
                case /* string parent_message_id */ 6:
                    message.parentMessageId = reader.string();
                    break;
                case /* map<string, string> metadata */ 7:
                    this.binaryReadMap7(message.metadata, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap7(map: ThreadMessage["metadata"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof ThreadMessage["metadata"] | undefined, val: ThreadMessage["metadata"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for agency.thread.v1.ThreadMessage.metadata");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message: ThreadMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string message_id = 1; */
        if (message.messageId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.messageId);
        /* string thread_id = 2; */
        if (message.threadId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.threadId);
        /* string session_id = 3; */
        if (message.sessionId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.sessionId);
        /* agency.session.v1.Message message = 4; */
        if (message.message)
            Message.internalBinaryWrite(message.message, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp timestamp = 5; */
        if (message.timestamp)
            Timestamp.internalBinaryWrite(message.timestamp, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* string parent_message_id = 6; */
        if (message.parentMessageId !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.parentMessageId);
        /* map<string, string> metadata = 7; */
        for (let k of globalThis.Object.keys(message.metadata))
            writer.tag(7, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.metadata[k]).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.thread.v1.ThreadMessage
 */
export const ThreadMessage = new ThreadMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ThreadContext$Type extends MessageType<ThreadContext> {
    constructor() {
        super("agency.thread.v1.ThreadContext", [
            { no: 1, name: "thread_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 2, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 3, name: "workspace", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 4, name: "summary", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "32768" } } } },
            { no: 5, name: "key_facts", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { repeated: { maxItems: "100", items: { string: { minLen: "1", maxLen: "1024" } } } } } },
            { no: 6, name: "session_history", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ThreadSessionSummary, options: { "buf.validate.field": { repeated: { maxItems: "100" } } } },
            { no: 7, name: "updated_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 8, name: "created_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 9, name: "revision", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value?: PartialMessage<ThreadContext>): ThreadContext {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.threadId = "";
        message.tenant = "";
        message.workspace = "";
        message.summary = "";
        message.keyFacts = [];
        message.sessionHistory = [];
        message.revision = 0n;
        if (value !== undefined)
            reflectionMergePartial<ThreadContext>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ThreadContext): ThreadContext {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string thread_id */ 1:
                    message.threadId = reader.string();
                    break;
                case /* string tenant */ 2:
                    message.tenant = reader.string();
                    break;
                case /* string workspace */ 3:
                    message.workspace = reader.string();
                    break;
                case /* string summary */ 4:
                    message.summary = reader.string();
                    break;
                case /* repeated string key_facts */ 5:
                    message.keyFacts.push(reader.string());
                    break;
                case /* repeated agency.thread.v1.ThreadSessionSummary session_history */ 6:
                    message.sessionHistory.push(ThreadSessionSummary.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* google.protobuf.Timestamp updated_at */ 7:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* google.protobuf.Timestamp created_at */ 8:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* uint64 revision */ 9:
                    message.revision = reader.uint64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ThreadContext, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string thread_id = 1; */
        if (message.threadId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.threadId);
        /* string tenant = 2; */
        if (message.tenant !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.tenant);
        /* string workspace = 3; */
        if (message.workspace !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.workspace);
        /* string summary = 4; */
        if (message.summary !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.summary);
        /* repeated string key_facts = 5; */
        for (let i = 0; i < message.keyFacts.length; i++)
            writer.tag(5, WireType.LengthDelimited).string(message.keyFacts[i]);
        /* repeated agency.thread.v1.ThreadSessionSummary session_history = 6; */
        for (let i = 0; i < message.sessionHistory.length; i++)
            ThreadSessionSummary.internalBinaryWrite(message.sessionHistory[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 7; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 8; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* uint64 revision = 9; */
        if (message.revision !== 0n)
            writer.tag(9, WireType.Varint).uint64(message.revision);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.thread.v1.ThreadContext
 */
export const ThreadContext = new ThreadContext$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ThreadSessionSummary$Type extends MessageType<ThreadSessionSummary> {
    constructor() {
        super("agency.thread.v1.ThreadSessionSummary", [
            { no: 1, name: "session_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 2, name: "goal", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "2048" } } } },
            { no: 3, name: "outcome", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "4096" } } } },
            { no: 4, name: "completed_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 5, name: "status", kind: "enum", T: () => ["agency.session.v1.SessionStatus", SessionStatus, "SESSION_STATUS_"], options: { "buf.validate.field": { enum: { definedOnly: true, notIn: [0] } } } }
        ]);
    }
    create(value?: PartialMessage<ThreadSessionSummary>): ThreadSessionSummary {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.sessionId = "";
        message.goal = "";
        message.outcome = "";
        message.status = 0;
        if (value !== undefined)
            reflectionMergePartial<ThreadSessionSummary>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ThreadSessionSummary): ThreadSessionSummary {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string session_id */ 1:
                    message.sessionId = reader.string();
                    break;
                case /* string goal */ 2:
                    message.goal = reader.string();
                    break;
                case /* string outcome */ 3:
                    message.outcome = reader.string();
                    break;
                case /* google.protobuf.Timestamp completed_at */ 4:
                    message.completedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.completedAt);
                    break;
                case /* agency.session.v1.SessionStatus status */ 5:
                    message.status = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ThreadSessionSummary, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string session_id = 1; */
        if (message.sessionId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.sessionId);
        /* string goal = 2; */
        if (message.goal !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.goal);
        /* string outcome = 3; */
        if (message.outcome !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.outcome);
        /* google.protobuf.Timestamp completed_at = 4; */
        if (message.completedAt)
            Timestamp.internalBinaryWrite(message.completedAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* agency.session.v1.SessionStatus status = 5; */
        if (message.status !== 0)
            writer.tag(5, WireType.Varint).int32(message.status);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.thread.v1.ThreadSessionSummary
 */
export const ThreadSessionSummary = new ThreadSessionSummary$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ThreadMetadata$Type extends MessageType<ThreadMetadata> {
    constructor() {
        super("agency.thread.v1.ThreadMetadata", [
            { no: 1, name: "thread_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 2, name: "title", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "256" } } } },
            { no: 3, name: "tags", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { repeated: { maxItems: "20", items: { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9_-]*[a-z0-9]$" } } } } } },
            { no: 4, name: "participants", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { repeated: { maxItems: "100", items: { string: { minLen: "1", maxLen: "256" } } } } } },
            { no: 5, name: "created_by", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 6, name: "created_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 7, name: "updated_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 8, name: "archived", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 9, name: "archived_at", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<ThreadMetadata>): ThreadMetadata {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.threadId = "";
        message.title = "";
        message.tags = [];
        message.participants = [];
        message.createdBy = "";
        message.archived = false;
        if (value !== undefined)
            reflectionMergePartial<ThreadMetadata>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ThreadMetadata): ThreadMetadata {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string thread_id */ 1:
                    message.threadId = reader.string();
                    break;
                case /* string title */ 2:
                    message.title = reader.string();
                    break;
                case /* repeated string tags */ 3:
                    message.tags.push(reader.string());
                    break;
                case /* repeated string participants */ 4:
                    message.participants.push(reader.string());
                    break;
                case /* string created_by */ 5:
                    message.createdBy = reader.string();
                    break;
                case /* google.protobuf.Timestamp created_at */ 6:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 7:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* bool archived */ 8:
                    message.archived = reader.bool();
                    break;
                case /* google.protobuf.Timestamp archived_at */ 9:
                    message.archivedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.archivedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ThreadMetadata, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string thread_id = 1; */
        if (message.threadId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.threadId);
        /* string title = 2; */
        if (message.title !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.title);
        /* repeated string tags = 3; */
        for (let i = 0; i < message.tags.length; i++)
            writer.tag(3, WireType.LengthDelimited).string(message.tags[i]);
        /* repeated string participants = 4; */
        for (let i = 0; i < message.participants.length; i++)
            writer.tag(4, WireType.LengthDelimited).string(message.participants[i]);
        /* string created_by = 5; */
        if (message.createdBy !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.createdBy);
        /* google.protobuf.Timestamp created_at = 6; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 7; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* bool archived = 8; */
        if (message.archived !== false)
            writer.tag(8, WireType.Varint).bool(message.archived);
        /* google.protobuf.Timestamp archived_at = 9; */
        if (message.archivedAt)
            Timestamp.internalBinaryWrite(message.archivedAt, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.thread.v1.ThreadMetadata
 */
export const ThreadMetadata = new ThreadMetadata$Type();
